export const CeilingHeaderEnumValue = {
  HighCeiling: '549c2ccd-9acb-4db7-a0f5-d86b6b52a062',
  LowCeiling: '5417a063-9554-4d62-ba3a-2ff136a4995c',
};

export const CeilingHeaderEnum = [
  {
    value: CeilingHeaderEnumValue.HighCeiling,
    labelFrench: 'Plafond haut ( plus de 9\'2")',
    customLabelFrench: 'Plafond haut ( plus de 9\'4")',
    labelEnglish: 'High ceiling (more than 9\'2")',
    customLabelEnglish: 'High ceiling (more than 9\'4")',
  },
  {
    value: CeilingHeaderEnumValue.LowCeiling,
    labelFrench: 'Plafond bas ( moins que 9\'2")',
    customLabelFrench: 'Plafond bas ( moins que 9\'4")',
    labelEnglish: 'Low ceiling (less than 9\'2")',
    customLabelEnglish: 'Low ceiling (less than 9\'4")',
  },
];

export default CeilingHeaderEnum;
